import React from 'react';
import { Paper, Text } from '@mantine/core';
import moment from 'moment';

import { EORIGIN_DATE_FORMAT } from '@e-origin/shared';

import { UTB_REPORT_OBJECTION_CLAUSE_DAYS } from '../constants';
import { TranslationFn } from '../translations';

interface UTBObjectionClauseProps {
  t: TranslationFn;
}

export const UTBObjectionClause = ({ t }: UTBObjectionClauseProps) => {
  return (
    <Paper mb="xs" p="xs">
      <Text>{t('OBJECTION_CLAUSE.DISAGREE')}</Text>
      <Text>{t('OBJECTION_CLAUSE.PO_BOX')}</Text>
      <Text>{t('OBJECTION_CLAUSE.POSTAL_CODE')}</Text>
      <Text mt="xl">{t('OBJECTION_CLAUSE.REASON', { date: moment().add(UTB_REPORT_OBJECTION_CLAUSE_DAYS, 'd').format(EORIGIN_DATE_FORMAT) })}</Text>
    </Paper>
  );
};
